import { action } from "satcheljs";

const resetUniqueShiftStore = action(
    "resetUniqueShiftStore", () => ({})
);

export default resetUniqueShiftStore;
